import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch from "../../../utils/hooks/useFetch.ts";

export interface IBookingComment {
  bookingId: number;
  comment: string;
}

export const useBookingComments = (date: string) => {
  const fetch = useFetch();
  const { token } = useAuth();

  const { data, isLoading, isError, error } = useQuery<IBookingComment[] | null, Error, IBookingComment[]>({
    queryKey: ["booking-comments", date],
    queryFn: () =>
      fetch<IBookingComment[]>(`/booking/comments?date=${encodeURIComponent(date)}`, {
        method: "GET",
      }, true, token),
    staleTime: 0,
    gcTime: 0,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting booking comments");
    }
  }, [error?.message, isError]);

  return {
    data,
    isFetching: isLoading,
  };
};
